import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class GeogPoint extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.geogpoint',
        group: 'Parsers',
        title: 'ST GeogPoint',
        description: `
      This component creates a new table with an additional column with point geographies from latitude and longitude columns.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'lat',
          type: WorkflowComponentParamType.Column,
          title: 'Latitude column',
          parent: 'source',
          dataType: [ColumnDataType.Number, ColumnDataType.String]
        },
        {
          name: 'lon',
          type: WorkflowComponentParamType.Column,
          title: 'Longitude column',
          parent: 'source',
          dataType: [ColumnDataType.Number, ColumnDataType.String]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
        return dedent`SELECT ST_GEOGPOINT(
          CAST(${params.lon} as FLOAT64),
          CAST(${params.lat} as FLOAT64)
        ) AS  geom, *
        FROM ${connection.quoteName(params.source as string)}`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40, geom) */
          ${connection.processOutputGeogColumn(`ST_POINT(
  CAST(${params.lon} as FLOAT),
  CAST(${params.lat} as FLOAT)
)`)} AS geom, *
        FROM ${connection.quoteName(params.source as string)}`
      case Provider.Oracle:
        return dedent`SELECT
          SDO_GEOMETRY(2001, 4326, SDO_POINT_TYPE(
            CAST(${params.lon} AS NUMBER),
            CAST(${params.lat} AS NUMBER),
            NULL
          ), NULL, NULL) AS "geom", t.*
        FROM ${connection.quoteName(params.source as string)} t`
      default:
        return dedent`SELECT ${connection.processOutputGeogColumn(`ST_POINT(
          CAST(${params.lon} as FLOAT),
          CAST(${params.lat} as FLOAT)
        )`)} AS geom, *
                      FROM ${connection.quoteName(params.source as string)}`
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, connection }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: 'geom',
      type: connection.getGeoDataType()
    })
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { GeogPoint }
